"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));

var _paragraph = _interopRequireDefault(require("@ckeditor/ckeditor5-paragraph/src/paragraph"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var GrooveParagraphNoMargin = /*#__PURE__*/function (_Plugin) {
  (0, _inherits2["default"])(GrooveParagraphNoMargin, _Plugin);

  var _super = _createSuper(GrooveParagraphNoMargin);

  function GrooveParagraphNoMargin() {
    (0, _classCallCheck2["default"])(this, GrooveParagraphNoMargin);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(GrooveParagraphNoMargin, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var model = editor.model; // extend the model created in CKEditor Paragraph plugin
      // https://github.com/ckeditor/ckeditor5/blob/master/packages/ckeditor5-paragraph/src/paragraph.js#L48=

      model.schema.extend('paragraph'); // [SOLUTION] convert from the model 'paragraph' (<P>) applied by built-in CKEditor Paragraph Plugin on Enter
      // to a <div> instead.
      // (and vice versa, this is an upcast & downcast conversion)
      // Also, higher converterPriority than the default Paragraph converter (which is low)

      editor.conversion["for"]('dataDowncast').elementToElement({
        model: 'paragraph',
        view: 'div',
        converterPriority: 'high'
      }); // Conversion for rendering the editor content to the user for editing

      editor.conversion["for"]('editingDowncast').elementToElement({
        model: 'paragraph',
        view: 'div',
        converterPriority: 'high'
      }); // [ALT SOLUTION] applying inline 0-margin styles to each paragraph created
      // convert from the model 'paragraph' (<P>) applied by built-in CKEditor Paragraph Plugin on Enter
      // to a <P> with no margins
      // (and vice versa, this is an upcast & downcast conversion)
      // Also, higher converterPriority than the default Paragraph converter (which is low)

      /* editor.conversion.for('dataDowncast').elementToElement({
        model: 'paragraph',
        // https://ckeditor.com/docs/ckeditor5/latest/api/module_engine_view_elementdefinition-ElementDefinition.html
        view: {
          name: 'p',
          // remove browser default p margin top and bottom
          styles: {
            'margin-top': '0',
            'margin-bottom': '0',
          },
        },
        converterPriority: 'high',
      }) */
    }
  }], [{
    key: "requires",
    get: function get() {
      return [_paragraph["default"]];
    }
  }]);
  return GrooveParagraphNoMargin;
}(_plugin["default"]);

exports["default"] = GrooveParagraphNoMargin;
//# sourceMappingURL=index.js.map